export const OFFTAKER_ONLY_STATUS_OPTIONS = {
  notStarted: "Not started",
  offerMade: "Offer made",
  operationalDemo: "Operational (demo)",
  operational: "Operational",
};

export const STATUS_OPTIONS: Record<string, string> = {
  notStarted: "Not started",
  offerMade: "Offer made",
  designsAndValidating: "Designs and validating",
  pendingSignatures: "Pending signatures",
  constructionPlanning: "Construction planning",
  installationInProgress: "Installation in progress",
  operationalDemo: "Operational (demo)",
  operational: "Operational",
  closedLost: "Closed / Lost",
};

// Legacy statuses — only shown on sites that already have them
export const LEGACY_STATUS_OPTIONS: Record<string, string> = {
  contractSigned: "Contract signed",
  loaPending: "LOA pending",
  gridAppPendingSurveyInProgress: "Grid app pending; Survey in progress",
  gridAppPendingSurveyCompleted: "Grid app pending; Survey completed",
  constructionPrelimsInProgress: "Construction prelims in progress",
  installationRoofWorks: "Installation - roof works",
  installationElectrical: "Installation - electrical",
  witnessTestingInProgress: "Witness testing in progress",
  waitingOnDnoWitnessTest: "Waiting on DNO - Witness test",
};

export const getStatusOptionsForSite = (
  currentStatus: string
): Record<string, string> => {
  if (currentStatus in LEGACY_STATUS_OPTIONS) {
    return { ...STATUS_OPTIONS, [currentStatus]: LEGACY_STATUS_OPTIONS[currentStatus] };
  }
  return STATUS_OPTIONS;
};

export const STATUS_WEIGHTS = {
  notStarted: 0,
  offerMade: 1,
  designsAndValidating: 2,
  pendingSignatures: 3,
  constructionPlanning: 4,
  installationInProgress: 5,
  operationalDemo: 6,
  operational: 7,
  closedLost: 8,
  // Legacy statuses
  contractSigned: 1,
  loaPending: 2,
  gridAppPendingSurveyInProgress: 3,
  gridAppPendingSurveyCompleted: 4,
  constructionPrelimsInProgress: 5,
  installationRoofWorks: 6,
  installationElectrical: 7,
  witnessTestingInProgress: 8,
  waitingOnDnoWitnessTest: 9,
};

export const OPERATIONAL_STATUSES = new Set([
  "installationInProgress",
  "operational",
  // Legacy statuses
  "installationElectrical",
  "witnessTestingInProgress",
  "waitingOnDnoWitnessTest",
]);

export const IN_PROGRESS_STATUSES = new Set([
  "designsAndValidating",
  "constructionPlanning",
  "installationInProgress",
  // Legacy statuses
  "constructionPrelimsInProgress",
  "installationRoofWorks",
  "installationElectrical",
  "witnessTestingInProgress",
  "waitingOnDnoWitnessTest",
]);
